import React from 'react';
import Select from 'react-select';

const MultiSelectSearch = ({
  name,
  value,
  onChange,
  options,
  placeholder = "Seleccione",
  isDisabled = false,
  isClearable = true,
  isLoading = false,
  noOptionsMessage = "No se encontraron opciones",
  loadingMessage = "Cargando...",
  isMulti = true,
}) => {
  return (
    <Select
      isMulti
      name={name}
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isClearable={isClearable}
      isSearchable
      isLoading={isLoading}
      noOptionsMessage={() => noOptionsMessage}
      loadingMessage={() => loadingMessage}
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: '40px',
          border: '1px solid #D1D5DB',
          borderRadius: '6px',
          boxShadow: state.isFocused ? 'none' : base.boxShadow,
          borderColor: state.isFocused ? '#D1D5DB' : base.borderColor,
          '&:hover': {
            borderColor: '#D1D5DB'
          }
        }),
        placeholder: (base) => ({
          ...base,
          color: '#6B7280',
          fontSize: '14px',
          fontFamily: 'ITC-book',
        }),
        menu: (base) => ({
          ...base,
          borderRadius: '8px',
          overflow: 'hidden',
          zIndex: 9999
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isSelected ? '#E6F7FF' : state.isFocused ? '#F7F8F9' : 'white',
          color: '#1B1F26',
          fontFamily: 'ITC-book',
          fontSize: '14px',
          '&:active': {
            backgroundColor: '#E6F7FF'
          }
        }),
        multiValue: (base) => ({
          ...base,
          backgroundColor: '#E6F7FF',
          borderRadius: '4px'
        }),
        multiValueLabel: (base) => ({
          ...base,
          color: '#1B1F26',
          fontFamily: 'ITC-book',
          fontSize: '14px'
        }),
        multiValueRemove: (base) => ({
          ...base,
          color: '#6B7280',
          '&:hover': {
            backgroundColor: '#D1D5DB',
            color: '#1B1F26'
          }
        })
      }}
    />
  );
};

export default MultiSelectSearch;